import React from "react";
import { Button } from "../../../components/ui/button";
import { Empty } from "../../../components/founder/ui";
import { Link2 } from "lucide-react";

function labelFor(q, val) {
  if (val == null || val === "") return null;
  const opts = Object.fromEntries((q.options || []).map((o) => [o.value, o.label]));
  if (Array.isArray(val)) return val.map((v) => opts[v] || v).join(", ");
  return opts[val] || val;
}

export default function IntakeTab({ ws, sendIntake }) {
  const session = ws.intake;
  const answers = session?.answers || {};
  const { sections, questions } = ws.questions;

  if (!session) {
    return (
      <div className="lr-card p-8 text-center max-w-lg">
        <p className="text-lr-charcoal mb-4">No assessment has been sent yet.</p>
        <Button onClick={sendIntake} className="bg-lr-olive hover:bg-[#3d4230] text-lr-cream rounded-[4px]">
          <Link2 className="h-4 w-4 mr-1.5" /> Generate Assessment Link
        </Button>
      </div>
    );
  }

  const answered = questions.filter((q) => answers[q.id] != null && answers[q.id] !== "");
  const bySection = sections.map((s) => ({ s, items: answered.filter((q) => q.section === s.key) })).filter((g) => g.items.length);

  return (
    <div className="max-w-3xl space-y-6">
      <div className="flex items-center gap-3">
        <span className={`text-xs px-2.5 py-1 rounded-[3px] ${session.status === "complete" ? "bg-lr-olive/15 text-lr-olive" : "bg-lr-clay/15 text-lr-clay"}`}>
          {session.status === "complete" ? "Assessment complete" : "In progress"}
        </span>
        <span className="text-sm text-lr-leather">{answered.length} answered</span>
      </div>

      {answered.length === 0 ? <Empty>Client hasn't started yet.</Empty> : bySection.map(({ s, items }) => (
        <div key={s.key} className="lr-card p-5" data-testid={`intake-section-${s.key}`}>
          <h3 className="font-serif text-lg text-lr-charcoal mb-4">{s.title}</h3>
          <div className="space-y-4">
            {items.map((q) => (
              <div key={q.id}>
                <div className="text-sm text-lr-leather">{q.prompt}</div>
                <div className="text-lr-charcoal mt-1">{labelFor(q, answers[q.id])}</div>
                <div className="text-[10px] tracking-wide text-lr-leather/70 mt-1">CLIENT_REPORTED</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
